export const MAX_ZOOM = 20;
export const MIN_ZOOM = 5;
export const INITIAL_ZOOM = 6;
export const DEFAULT_ZOOM = 16;
export const CENTER_ZOOM = 16;
export const SEARCH_ZOOM = 16;
export const DEFAULT_CENTER = { lat: 59, lng: 15 };
export const BREAKPOINT = 1024;
